import { createSlice } from "@reduxjs/toolkit";
import listStudyResearch from "@custom/rtk-apis/studyResearch/listStudyResearch";

export interface StudyResearchState {
  data: any;
  status: string;
  loading: boolean;
  successMessage: string | null;
  errorMessage: string | null;
}

const initialState: StudyResearchState = {
  data: [],
  status: '',
  loading: false,
  successMessage: null,
  errorMessage: null,
};

const listStudyResearchSlice = createSlice({
  name: 'studyResearch',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(listStudyResearch.pending, (state) => {
        state.loading = true;
        state.status = 'pending';
        state.successMessage = null;
        state.errorMessage = null;
      })
      .addCase(listStudyResearch.fulfilled, (state, {payload}) => {
        state.data = payload?.result;
        state.loading = false;
        state.status = payload?.status;
        state.successMessage = payload?.msg;
        state.errorMessage = null;
      })
      .addCase(listStudyResearch.rejected, (state, {payload}) => {
        state.data = [];
        state.loading = false;
        state.status = 'failure';
        state.successMessage = null;
        state.errorMessage = typeof payload === 'string' ? payload : 'Failed to list study reserach data.';
      });
  }
});

export default listStudyResearchSlice.reducer;
